module.exports = __webpack_public_path__ + "officialStatic/img/tlr.5721c7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/tlr.png
// module id = CE0Y
// module chunks = 0